import script from "./SegmentDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./SegmentDetails.vue?vue&type=script&setup=true&lang=js"

import "./SegmentDetails.vue?vue&type=style&index=0&id=6f622dae&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f622dae"]])

export default __exports__